import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { useReplyThread } from '../hooks/useReplyThread';
import { useOutreachPlan } from '../hooks/useOutreachPlan';
import { inboxMessages as messages } from './inboxMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * "Asks for payment" (design outreach-v2 m2, spec §4.6): fixed Music24 text, never AI text and never
 * Plug, and no suggested answer. "Archive" marks it handled; "This is a mistake" relabels the thread.
 */
const PaymentWarningComponent: React.FC<{ accountId: number; replyUuid: string }> = ({ accountId, replyUuid }) => {
  const intl = useIntl();
  const { isDemo } = useOutreachPlan();
  const { setLabel, markHandled } = useReplyThread(accountId, replyUuid);
  return (
    <>
      <div className={`${shared.alert} ${shared.alertWarn}`} data-testid="payment-warning">
        <FontAwesomeIcon icon={faTriangleExclamation} className={shared.alertIcon} />
        <div>
          <b>{intl.formatMessage(messages.paymentTitle)}</b> {withBrandWord(intl.formatMessage(messages.paymentBody))}
        </div>
      </div>
      <div className={shared.row}>
        <SMLButton
          size="sm"
          outline
          omitCap
          onClick={() => markHandled(replyUuid).catch(console.error)}
          disabled={isDemo}
        >
          {intl.formatMessage(messages.archive)}
        </SMLButton>
        <SMLButton
          size="sm"
          outline
          omitCap
          onClick={() => setLabel({ replyUuid, label: 'other' }).catch(console.error)}
          disabled={isDemo}
        >
          {intl.formatMessage(messages.notPayment)}
        </SMLButton>
      </div>
    </>
  );
};

export const PaymentWarning = TypedMemo(PaymentWarningComponent);
